<template>
  <div class="admin-header">
    <v-container fluid class="px-0">
      <v-row class="flex justify-space-between" no-gutters>
        <!-- Logo/Title Section -->

        <v-col cols="8" lg="6" align-self="center">
          <div class="d-flex align-start flex-column">
            <div class="d-flex align-center">
              <v-icon size="24" class="mr-2" color="primary"
                >mdi-account-group-outline</v-icon
              >
              <span class="font-roboto font-weight-medium text-h5">{{
                $t('message.members_header_title')
              }}</span>
            </div>
            <div class="page-subtitle">
              {{ $t('message.members_header_description') }}
            </div>
          </div>
        </v-col>

        <!-- Actions Section -->
        <v-col cols="4" lg="6" align-self="center">
          <v-row
            cols="12"
            sm="6"
            md="4"
            no-gutters
            class="d-flex align-center justify-end"
          >
            <v-col cols="auto" class="d-none d-lg-flex">
              <PlusButton
                small
                intent="primary"
                class="mr-5"
                @click="$emit('add-member')"
              >
                <span class="font-roboto text-button d-none d-md-inline">{{
                  $t('message.add_member')
                }}</span>
              </PlusButton>
              <PlusButton
                small
                @click="$emit('invite-member')"
              >
                <span class="font-roboto text-button d-none d-md-inline">{{
                  $t('message.invite_new_members')
                }}</span>
              </PlusButton>
            </v-col>

            <v-col cols="auto" class="d-flex justify-end">
              <v-menu elevation="0" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-badge
                      class="mr-2"
                      v-if="upcomingBirthdays"
                      bordered
                      color="accent"
                      icon="mdi-cake-variant-outline"
                      overlap
                    >
                      <v-btn
                        class="ml-5 rounded-sm"
                        fab
                        small
                        outlined
                        elevation="0"
                        color="primary"
                      >
                        <v-icon size="20" class="mr-1"
                          >mdi-dots-vertical</v-icon
                        >
                      </v-btn>
                    </v-badge>
                    <v-btn
                      v-else
                      class="ml-5 rounded-sm"
                      fab
                      small
                      outlined
                      elevation="0"
                      color="primary"
                    >
                      <v-icon size="20">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </span>
                </template>
                <v-list class="font-roboto text-body-1">
                  <v-list-item
                    class="d-flex d-lg-none"
                    @click="$emit('add-member')"
                  >
                    <v-list-item-title class="clickable">
                      <span>{{ $t('message.add_member') }}</span>
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    class="d-flex d-lg-none"
                    @click="$emit('invite-member')"
                  >
                    <v-list-item-title class="clickable">
                      <span>{{ $t('message.invite_new_members') }}</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$emit('upcoming-birthdays-dialog')">
                    <v-list-item-title class="clickable">
                      <span>{{ $t('message.upcoming_birthdays') }}</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="messagesThread"
                    @click="$emit('go-to-messages-thread')"
                  >
                    <v-list-item-title class="clickable">
                      <span>{{ $t('message.go_to_messsages_thread') }}</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-else
                    @click="$emit('init-messages-thread-dialog')"
                  >
                    <v-list-item-title class="clickable">
                      <span>{{ $t('message.init_academy_messages') }}</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$emit('navigate-to-advanced-search')">
                      <v-list-item-title class="clickable">

                        <span>{{ $t("message.advanced_search")
                        }}</span>
                      </v-list-item-title>
                    </v-list-item>
                  <v-list-item @click="$emit('get-members-csv')">
                    <v-list-item-title class="clickable">
                      <span>{{ $t('message.download_list') }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PlusButton from '@/components/plus/PlusButton.vue';

export default {
  name: 'AdminPlusHeader',
  components: {
    PlusButton,
  },
  props: {
    payingCount: {
      type: Number,
      default: 0,
    },
    freeCount: {
      type: Number,
      default: 0,
    },
    upcomingBirthdays: {
      type: [Array, Boolean],
      default: false,
    },
    messagesThread: {
      type: [Object, Boolean],
      default: false,
    },
  },
  emits: [
    'add-member',
    'invite-member',
    'go-to-messages-thread',
    'init-messages-thread-dialog',
    'navigate-to-advanced-search',
    'upcoming-birthdays-dialog',
    'get-members-csv',
  ],
  methods: {
    isSmallerDisplay() {
      return this.$vuetify.breakpoint.xs;
    },
  },
};
</script>

<style scoped>
.admin-header {
  margin-bottom: 1rem;
  /* plusBorder is theme-aware via Vuetify customProperties: #E0E0E0 (light) / #424242 (dark). */
  border-bottom: 1px solid var(--v-plusBorder-base);
  padding-bottom: 1rem;
  height: auto;
  flex: 1;
}
</style>
